import React from "react";

import { Shared } from "utility/shared";

export const CustomHTMLMessage: React.FC<{ message: string }> = ({
	message,
}) => {
	return (
		<React.Fragment>
			<span
				dangerouslySetInnerHTML={{
					__html: Shared.getSanitizedValue(message),
				}}
			/>
		</React.Fragment>
	);
};
